export const links = {
  // eslint-disable-next-line max-len
  mobile: "https://prtord.com/?siteId=wl3&cobrandId=257522&superCategoryName=girls&categoryName=girl&pageName=random&performerName=&prm[psid]=RedGIFs&prm[pstool]=205_1&prm[psprogram]=cbrnd&prm[campaign_id]=&subAffId={SUBAFFID}&prm[utm_source]=circle&filters=",
  desktop: "http://go.goaserv.com/redirect.go?pid=390&spaceid=1244530",
};
